import { Component, OnInit } from '@angular/core';
import { LanguageService } from '../../services/language.service';

@Component({
    selector: 'app-agb',
    templateUrl: 'agb.component.html',
    styleUrls: ['../pages.scss'],
})

export class AGBComponent {
    activeLanguage = 'german';
    constructor(private ls: LanguageService) {
      ls.getLanguage().subscribe(val => this.activeLanguage = val);
    }

}


// WEBPACK FOOTER //
// ./src/app/components/agb/agb.component.ts